module.exports = require('./dist/offers');
